import { WorkflowRunStatus } from "types";

const RESUMABLE_LAST_EVENTS = new Set([
  "node:completed",
  "node:completed_with_errors",
  "node:skipped",
]);

type Run = {
  status: WorkflowRunStatus;
  workflowEvents: readonly {
    type: string;
    seq: number;
    deletedAt?: string | null;
  }[];
};

const lastEventOf = (run: Run) =>
  run.workflowEvents
    .filter((event) => !event.deletedAt)
    .sort((a, b) => b.seq - a.seq)[0];

export const isRunBlockedOnConfig = (run: Pick<Run, "status">): boolean =>
  run.status === WorkflowRunStatus.Blocked;

export const canSignalWorkflowRun = (
  run: Run,
  hasPermission: boolean,
): boolean => {
  if (!hasPermission) return false;
  if (isRunBlockedOnConfig(run)) return true;
  if (run.status !== WorkflowRunStatus.Running) return false;

  const lastEvent = lastEventOf(run);

  return !!lastEvent && RESUMABLE_LAST_EVENTS.has(lastEvent.type);
};
